import Button from "@app/components/move2Library/Button/Button"
import { useGetStrings } from "@app/store/service/cmsService"
import { Modal, useModal } from "@tecreation/funnel-components"

import { useRaiseError } from "@app/store/actions/errorActions"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import { useCallback } from "react"
import "./styles.css"

const HelpDeskButton = ({ children, onClick }) => {
	return (
		<div className="helpdesk-button text-center color-bg-neutral-300 p-4" onClick={onClick}>
			{children}
		</div>
	)
}

export default function CashregisterUtilitiesModal() {
	const { hideModal } = useModal()
	const {
		data: { buttonClose },
	} = useGetStrings()
	const raiseError = useRaiseError()

	const executeFunction = useCallback(func => {
		KioskBridge.execute(func).catch(e => {
			raiseError(e instanceof Error ? e : new Error(e))
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Modal>
			<Modal.Header>Helpdesk</Modal.Header>
			<Modal.Body>
				<div className="" style={{ gap: "16px 16px", display: "grid", gridTemplateColumns: "306px 306px", minWidth: "500px" }}>
					<HelpDeskButton onClick={() => executeFunction("printer.kiosk.print.lastReceipt")}>Erneuter Belegdruck</HelpDeskButton>
					<HelpDeskButton onClick={() => executeFunction("hardware.kiosk.test.printer")}>Test Print</HelpDeskButton>
					<HelpDeskButton onClick={() => executeFunction("cashregister.shift.kiosk.open")}>Schichtabschluss</HelpDeskButton>
					<HelpDeskButton onClick={() => executeFunction("cashregister.kiosk.close")}>Schließen</HelpDeskButton>
					<HelpDeskButton onClick={() => executeFunction("index.refresh.kiosk.openRefresh")}>Aktualisierung</HelpDeskButton>
					<HelpDeskButton onClick={() => executeFunction("index.kiosk.openDevTools")}>Developer tools</HelpDeskButton>
					<HelpDeskButton onClick={() => executeFunction("cashregister.kiosk.restart")}>Restart Device</HelpDeskButton>
					<HelpDeskButton onClick={() => window.location.reload()}>Window Reload</HelpDeskButton>
					<HelpDeskButton onClick={() => executeFunction("receipt.history.kiosk.openHistory")}>Beleg Historie</HelpDeskButton>
					<HelpDeskButton onClick={() => executeFunction("cashDrawer.kiosk.open")}>Kassenschublade öffnen</HelpDeskButton>
				</div>
			</Modal.Body>
			<Modal.Footer className="flex flex-center">
				<Button style="primary" onClick={hideModal}>
					{buttonClose}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
